// Pay flow for both installments & commitments — shared state + submit handler.
import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { payInstallment } from "@/lib/installmentsApi";
import { refetchCommitments } from "@/lib/useCommitmentsCache";
import { refreshInstallments } from "@/lib/useInstallmentsCache";

export function useRecurringPay(AR) {
  const [pay, setPay] = useState(null); // { id, kind: "inst"|"com", amount }
  const [busy, setBusy] = useState(false);

  const submit = async (accountId) => {
    if (!pay) return;
    setBusy(true);
    try {
      if (pay.kind === "inst") {
        await payInstallment(pay.id, accountId);
        refreshInstallments();
      } else {
        await api.post(`/commitments/${pay.id}/pay`, { account_id: accountId });
        refetchCommitments();
      }
      window.dispatchEvent(new Event("malat:data-changed"));
      toast.success(AR ? "تم تسجيل الدفعة ✓" : "Payment recorded ✓");
      setPay(null);
    } catch { toast.error(AR ? "تعذّر" : "Error"); } finally { setBusy(false); }
  };

  return { pay, setPay, submit, busy };
}
